import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi"; // Icons for menu toggle
import Logo from "../assets/sab.png";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-scroll";
import  {scroller} from "react-scroll";
import {
  fetchLlmsData,
  fetchStudentPortalData,
  fetchOfficeData,
  fetchImsData,
} from "../redux/slicer/itServicesSlice";

// import Preloader from "../assets/sab.png";
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null); // Track which dropdown is open
  const location = useLocation(); // Hook to get current URL path
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    data: itServicesData,
    loading: itServicesLoading,
    error: itServicesError,
  } = useSelector((state) => state.services.llms);

  const {
    data: imsData,
    loading: imsLoading,
    error: imsError,
  } = useSelector((state) => state.services.ims);

  const {
    data: officeData,
    loading: officeLoading,
    error: officeError,
  } = useSelector((state) => state.services.office);

  const isLoading = itServicesLoading || imsLoading || officeLoading;
  const error = itServicesError || imsError || officeError;

  useEffect(() => {
    dispatch(fetchLlmsData());
    dispatch(fetchOfficeData());
    dispatch(fetchImsData());
  }, [dispatch]);

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        smooth: true,
        duration: 500,
        offset: -80, // Adjust as needed
      });
    }
  }, [location]);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        scroller.scrollTo(location.hash.substring(1), {
          smooth: true,
          duration: 800, // Adjust duration for smoother scrolling
          offset: -80, // Adjust for navbar height
        });
      }, 300); // Delay to allow page transition before scrolling
    }
  }, [location]);
  const handleLogoClick = () => {
    navigate("/");
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  // Array of navigation links
  const navLinks = [
    {
      path: "/",
      label: "HOME",
      dropdown: [
        { path: "/#patners", label: "Accreditations and Recognitions" }, // Corrected "Patners" to "Partners"
        { path: "/#gallery", label: "Gallery" },
      ],
    },
    {
      path: "/about-us",
      label: "ABOUT US",
      dropdown: [
        { path: "/about-us#history", label: "Our History" },
        { path: "/about-us#mission", label: "Vision & Mission" },
        { path: "/about-us#leadership", label: "Leadership Message" },
        { path: "/about-us#council", label: "Council" },
        { path: "/about-us#managment", label: "Board Of Management" }, // Corrected "Managment" to "Management"
        { path: "/about-us#studies", label: "Board Of Studies" },
      ],
    },
    {
      path: "/acadamics",
      label: "ACADEMIC PROGRAMMES",
      dropdown: [
        { path: "/acadamics#undergraduate", label: "Undergraduate programmes" },
        { path: "/acadamics#postGraduate", label: " Post Graduate programmes" },
        { path: "/acadamics#programs", label: "Affiliated programmes" },
        { path: "/acadamics#loan", label: "Interest Free Loan Scheme" }, // Corrected "Intrest" to "Interest" and "Schema" to "Scheme"
        { path: "/acadamics#careers", label: "Career Guidence & Internship" },
        { path: "/acadamics#cqa", label: "CQA" },
      ],
    },
    { path: "/it-services", label: "STUDENT SUPPORT",
      dropdown: [
        { path: "/it-services#service", label: "Service Menu" },
        { path: "/it-services#counselling", label: "Student Counselling" },
        { path: "/it-services#flyer", label: "Flyer Section" },
        { path: "/it-services#job", label: "Careers" },
        
        
      ],
     },

    {
      path: "/research-and-student-life",
      label: "RESEARCH & PUBLICATIONS",
      dropdown: [
        { path: "/research-and-student-life#src", label: "SAB SRC" },
        { path: "/research-and-student-life#publications", label: "Publications" },
        // {
        //   path: "/research-and-student-life#clubs",
        //   label: "Clubs & Societies",
        // }, // Corrected "Socities" to "Societies"
        // { path: "/research-and-student-life#events", label: "Student Events" },
        // { path: "/research-and-student-life#sports", label: "Sports" },
        // {
        //   path: "/research-and-student-life#careers",
        //   label: "Career Guidance & Internships", // Corrected "Guidens" to "Guidance"
        // },
      ],
    },

    {
      path: "/student-life",
      label: "STUDENT LIFE",
      dropdown: [
   
        {
          path: "/student-life#clubs",
          label: "Clubs & Societies",
        }, // Corrected "Socities" to "Societies"
        { path: "/student-life#events", label: "Student Events" },
        { path: "/student-life#sports", label: "Sports" },
        // { path: "/student-life#patners", label: "Training Patners" },
       
      ],
    },
    {
      path: "/gallery-and-news",
      label: "GALLERY & NEWS",
      dropdown: [
        { path: "/gallery-and-news#gallery", label: "Gallery" },
        { path: "/gallery-and-news#video", label: "Video Gallery" },
        { path: "/gallery-and-news#news", label: "News" },
 
      ],
    },

    // {
    //   path: "/careers",
    //   label: "CAREERS",
    //   dropdown: [
    //     { path: "/careers#flyer", label: "Flyer Section" },
    //     { path: "/careers#job", label: "Job Listing" }, // Corrected "Listning" to "Listing"
    //   ],
    // },
    {
      path: "/aluminai",
      label: "ALUMNI",
      dropdown: [
     
        { path: "/aluminai#news", label: "Alumni Latest News" },
        { path: "/aluminai#gallery", label: "Alumni Gallery" },
        { path: "/aluminai#directory", label: "Alumni Directory" },
        { path: "/aluminai#registration", label: "Alumni Registration" },
      ],
    },
    { path: "/contact-us", label: "CONTACT US" },
  ];

  return (
    <div>
      <nav className="bg-white py-2 shadow-md">
        <div className="flex justify-between items-center px-4">
          {/* Logo */}
          <img
            src={Logo}
            className="h-16 cursor-pointer"
            alt="Logo"
            onClick={handleLogoClick}
          />

          {/* Hamburger Menu (Mobile) */}
          {/* Hamburger Menu (Visible on sm and md) */}
          <div className="xl:hidden">
            <button onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? (
                <FiX className="text-3xl text-primary-color" />
              ) : (
                <FiMenu className="text-3xl text-primary-color" />
              )}
            </button>
          </div>

          {/* Desktop Navigation (Visible on lg, xl, and 2xl) */}
          <ul className="hidden xl:flex space-x-6 text-[0.72rem]  relative">
            {navLinks.map((link, index) => (
              <li
                key={index}
                className="relative"
                onMouseEnter={() => setDropdownOpen(link.label)}
                onMouseLeave={() => setDropdownOpen(null)}
              >
                <NavLink
                  to={link.path}
                  onClick={(e) => {
                    if (link.path.includes("#")) {
                      e.preventDefault(); // Prevent page reload
                      const sectionId = link.path.split("#")[1]; // Extract section ID
                      scroller.scrollTo(sectionId, {
                        smooth: true,
                        duration: 800,
                        offset: -80,
                      });
                    } else {
                      navigate(link.path);
                    }
                    setIsOpen(false); // Close menu after click (for mobile)
                  }}
                  className={`block font-sans text-primary-color font-bold transition-all ${
                    location.pathname === link.path.split("#")[0]
                      ? "underline underline-offset-8 text-primary-color"
                      : "hover:underline hover:underline-offset-8"
                  }`}
                >
                  {link.label}
                </NavLink>

                {/* Dropdown Menu for Desktop */}
                {link.dropdown && dropdownOpen === link.label && (
                  <ul className="absolute left-0 top-full bg-primary-color shadow-lg font-bold rounded-md w-60 py-2 z-50 border border-gray-300">
                    {link.dropdown.map((subLink, subIndex) => (
                      <li
                        key={subIndex}
                        className="px-4 py-2 hover:bg-Footer-color text-primary-color"
                      >
                        <NavLink
                          to={subLink.path}
                          className="block text-gray-800 text-white text-left uppercase"
                        >
                          {subLink.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          {/* Mobile Slide-in Menu (Visible on sm and md) */}
          <div
            className={`fixed top-0 left-0 w-[70%] h-full bg-white shadow-lg transform  ${
              isOpen ? "translate-x-0" : "-translate-x-full"
            } transition-transform duration-300 ease-in-out z-50 `}
          >
            <div className="flex justify-end p-4 ">
              <button onClick={() => setIsOpen(false)}>
                <FiX className="text-3xl text-primary-color" />
              </button>
            </div>

            <ul className="flex flex-col items-start p-6 space-y-6 text-lg ">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <NavLink
                    to={link.path}
                    onClick={() => setIsOpen(false)} // Close menu on link click
                    className={`block font-sans text-primary-color font-bold transition-all ${
                      location.pathname === link.path
                        ? "underline underline-offset-8 text-primary-color"
                        : "hover:underline hover:underline-offset-8"
                    }`}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Buttons (Desktop View - Visible on lg, xl, and 2xl) */}
          <div className="hidden xl:flex space-x-1 justify-end">
            {/* Mapping LMS Data */}
            {itServicesData.map((service, index) => (
              <button
                key={service.id || index}
                className="bg-primary-color text-white rounded-3xl w-[100px] h-8"
                onClick={() => window.open(service.url, "_blank")}
              >
                {service.name || "LMS"}
              </button>
            ))}

            {/* Mapping Smart Library Data */}
            {imsData.map((portal, index) => (
              <button
                key={portal.id || index}
                className="bg-primary-color text-white rounded-3xl w-[100px] h-8"
                onClick={() => window.open(portal.url, "_blank")}
              >
                {portal.name || "IMS"}
              </button>
            ))}

            <button
              className="bg-primary-color text-white rounded-3xl w-[100px] h-8"
              onClick={() => window.open("/degree-registration-apply")}
            >
              Apply Now
            </button>
          </div>

          {/* Mobile Slide-in Menu (Visible on sm and md) */}
          <div
            className={`fixed top-0 left-0 w-[70%] h-full bg-white shadow-lg transform ${
              isOpen ? "translate-x-0" : "-translate-x-full"
            } transition-transform duration-300 ease-in-out z-50 lg:hidden`}
          >
            <div className="flex justify-end p-4">
              <button onClick={() => setIsOpen(false)}>
                <FiX className="text-3xl text-primary-color" />
              </button>
            </div>

            <ul className="flex flex-col items-start p-6 space-y-6 text-sm"> {/*  text-lg  change to text-sm */}
              {navLinks.map((link) => (
                <li key={link.path}>
                  <NavLink
                    to={link.path}
                    onClick={() => setIsOpen(false)} // Close menu on link click
                    className={`block font-sans text-primary-color font-bold transition-all ${
                      location.pathname === link.path
                        ? "underline underline-offset-8 text-primary-color"
                        : "hover:underline hover:underline-offset-8"
                    }`}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>

            {/* Buttons Inside Hamburger Menu */}
            <div className="flex flex-col space-y-4 p-6">
              {/* Mapping LMS Data */}
              {itServicesData.map((service, index) => (
                <button
                  key={service.id || index}
                  className="bg-primary-color text-white rounded-3xl w-[100px] h-8 text-xs"  //text-xs
                  onClick={() => window.open(service.url, "_blank")}
                >
                  {service.name || "LMS"}
                </button>
              ))}

              {/* Mapping Smart Library Data */}
              {imsData.map((portal, index) => (
                <button
                  key={portal.id || index}
                  className="bg-primary-color text-white rounded-3xl w-[100px] h-8 text-xs" //text-xs
                  onClick={() => window.open(portal.url, "_blank")}
                >
                  {portal.name || "IMS"}
                </button>
              ))}

              <button
                className="bg-primary-color text-white rounded-3xl w-[100px] h-8 text-xs" //text-xs
                onClick={() => window.open("/degree-registration-apply")}
              >
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;